import type { InsurancePolicy } from '@/types/insurancePolicy';

const PRIORITY_ORDER: Record<string, number> = {
  Primary: 0,
  Secondary: 1,
  'Tertiary+': 2,
  Tertiary: 2
};

export const sortInsurancePolicies = (policies: InsurancePolicy[]) =>
  [...policies].sort((a, b) => {
    const aSelfPay = a.is_self_pay ? 1 : 0;
    const bSelfPay = b.is_self_pay ? 1 : 0;
    if (aSelfPay !== bSelfPay) return aSelfPay - bSelfPay;

    const aOrder = PRIORITY_ORDER[a.priority_type ?? ''] ?? 3;
    const bOrder = PRIORITY_ORDER[b.priority_type ?? ''] ?? 3;
    return aOrder - bOrder;
  });
